import { isRouteErrorResponse } from "react-router";
import { useEffect } from "react";
import { captureException } from "../services/sentry";
import { useTranslation } from "../config/i18n";
import { dismissStartupLoader } from "../utils/startup-loader";

export interface ErrorBoundaryProps {
  error: unknown;
}

export function ErrorBoundary({ error }: ErrorBoundaryProps) {
  const { t } = useTranslation();
  let message = t('errors.oops');
  let details = t('errors.unexpected');
  let stack: string | undefined;

  useEffect(() => {
    dismissStartupLoader();
    if (isRouteErrorResponse(error) && error.status === 404) {
      return;
    }
    captureException(error);
  }, [error]);

  if (isRouteErrorResponse(error)) {
    message = error.status === 404 ? "404" : t('common.error');
    details =
      error.status === 404
        ? t('errors.pageNotFound')
        : error.statusText || details;
  } else if (import.meta.env.DEV && error && error instanceof Error) {
    details = error.message;
    stack = error.stack;
  }

  return (
    <main className="pt-16 p-4 container mx-auto">
      <h1>{message}</h1>
      <p>{details}</p>
      {stack && (
        <pre className="w-full p-4 overflow-x-auto">
          <code>{stack}</code>
        </pre>
      )}
    </main>
  );
}
